//#region src/entities/error/constants.ts
var AgentErrorCodes = { LIMIT_REACHED: "LIMIT_REACHED" };
//#endregion
export { AgentErrorCodes };

//# sourceMappingURL=constants.js.map